import { textStyleCss } from 'src/theme/atlas';
import styled from 'styled-components';

export type ModalSize = 'small' | 'medium' | 'large';

export const ModalStyled = styled.dialog<{ size: ModalSize; show?: boolean }>`
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  margin: 0;
  display: ${(props) => (props.show ? 'flex' : 'none')};
  flex-direction: column;
  min-height: 152px;
  padding: 0;
  border-radius: 4px;
  border: none;
  ${(props) => {
    switch (props.size) {
      case 'small':
        return 'width: min(420px, 100vw); box-shadow: 0px 0px 1px 0px rgba(0, 0, 0, 0.40), 0px 12px 12px -6px rgba(0, 0, 0, 0.16);';
      case 'medium':
        return 'width: min(640px, 100vw); box-shadow: 0px 0px 1px 0px rgba(0, 0, 0, 0.40), 0px 12px 12px -6px rgba(0, 0, 0, 0.16);';
      case 'large':
        return 'width: min(840px, 100vw); box-shadow: 0px 0px 1px 0px rgba(0, 0, 0, 0.4), 0px 8px 24px -6px rgba(0, 0, 0, 0.16);';
    }
  }};
  ::backdrop {
    background-color: #000000;
    opacity: 0.7;
  }
`;

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 28px 20px 16px 20px;
`;

export const Title = styled.h1<{
  hasLargeText: boolean;
  hasContent: boolean;
}>`
  ${(props) =>
    textStyleCss(
      props.hasLargeText
        ? props.theme.atlas.typography.semantic.body
        : props.theme.atlas.typography.semantic.bodySmall,
    )}
  margin: 0;
  ${(props) =>
    props.hasContent ? 'margin-bottom: 12px;' : 'margin-bottom: 0;'}
`;

export const Description = styled.section`
  margin: 0;
  ${({ theme }) => textStyleCss(theme.atlas.typography.semantic.bodySmall)};
  color: ${(props) => props.theme.atlas.semantic.color.type.muted};
  p:last-child {
    margin-bottom: 0;
  }
  white-space: normal;
`;

export const Bottom = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  width: 100%;
  margin-top: 28px;
`;

export const BottomActionBar = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  margin-top: 16px;
`;

export const BottomMessageContainer = styled.div`
  flex-grow: 1;
`;

export const ButtonContainer = styled.div`
  display: grid;
  grid-auto-flow: column;
  grid-auto-columns: 1fr;
  width: fit-content;
  column-gap: 12px;
`;

export const TitleContainer = styled.div<{ hasPaddingBottom: boolean }>`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  ${(props) => (props.hasPaddingBottom ? 'padding-bottom: 40px;' : '')}
`;

export const InvisibleWedge = styled.div`
  visibility: hidden;
`;

export const IconButton = styled.div`
  cursor: pointer;
`;
